export default [
  /**
   * 这里是脸到公众号与小云爱学脸到相关页面
   */
  {
    path: '/face-parent/home/:active',
    redirect: '/face/home/:active',
  },
  {
    path: '/face/home/:active',
    name: 'face-home',
    component: () => import('@parent/views/face/home/home.vue'),
    meta: {
      vx_exclude_params: ['active'],
    },
  },
  {
    path: '/face-parent/detail/:id',
    redirect: '/face/detail/:id',
  },
  {
    path: '/face/detail/:id',
    name: 'face-detail',
    component: () => import('@parent/views/face/detail.vue'),
  },
  {
    path: '/face/collect/:stuId/:companyId',
    name: 'face-collect',
    component: () => import('@parent/views/face/home/collect.vue'),
  },
];
